export default __webpack_public_path__ + "static/media/icone-instagram-pink.98101f36.svg";